export default __webpack_public_path__ + "static/media/logo-white.dc3d6e95.svg";